import React, { ReactNode } from 'react'

type Props = {
  label: string
  value: string | ReactNode
}

export const LabelledValue = ({ label, value }: Props) => {
  return (
    <div>
      <b>{label}</b>: {value}
    </div>
  )
}
